import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient) {}

  getFianzas() {
    return this.http.get<any>(environment.url + '/Surety/getAllSureties');
  }

  getListBank() {
    return this.http.get<any>(environment.url + '/User/getAllBank');
  }

  pagarFianza(creditId) {
    return this.http.post<any>(
      environment.url + '/Surety/payBailFondeador?bailId=' + creditId,
      {},
    );
  }

  createUser(objUser) {
    return this.http.post<any>(
      environment.url + '/User/create/public',
      objUser,
    );
  }

  updateProfile(objUser) {
    return this.http.put(environment.url + '/User/update/profile', objUser);
  }

  getProfile(objUser) {
    return this.http.get(environment.url + '/User/get/profile?id=' + objUser);
  }

  getUser(objUser): Observable<any> {
    return this.http.get(environment.url + '/User/get?id=' + objUser);
  }

  updateFunder(payload) {
    return this.http.put<void>(
      `${environment.url}/User/update/fondeador`,
      payload,
    );
  }

  updatePassword(payload) {
    return this.http.put<void>(
      `${environment.url}/User/update/password`,
      payload,
    );
  }

  updatePasswordAdmin(payload) {
    return this.http.put<void>(
      `${environment.url}/User/update/password/admin`,
      payload,
    );
  }

  approvedUser(objAproved) {
    return this.http.put<any>(
      environment.url + environment.User + '/ApproveUser?id=' + objAproved,
      {},
    );
  }

  rejectUser(objRecject) {
    return this.http.put<any>(
      environment.url + environment.User + '/RejectedUser?id=' + objRecject,
      {},
    );
  }

  saveUser(objUser) {
    return this.http.post<any>(
      environment.url + environment.User + environment.create,
      objUser,
    );
  }

  editUser(objUser) {
    return this.http.post<any>(
      environment.url + environment.User + environment.update,
      objUser,
    );
  }

  deleteUser(id) {
    return this.http.post<any>(
      environment.url + environment.User + environment.disable + '?id=' + id,
      id,
    );
  }

  getusers() {
    return this.http.get<any>(
      environment.url + environment.User + environment.getAll,
    );
  }

  getUsersChild(id) {
    return this.http.get<any>(
      environment.url + environment.usersChild + '/get?id=' + id,
    );
  }

  createUsersChild(objUser) {
    return this.http.post<any>(
      environment.url + environment.usersChild + environment.create,
      objUser,
    );
  }

  disableUsersChild(objUser) {
    return this.http.post<any>(
      environment.url +
        environment.usersChild +
        environment.disable +
        '?id=' +
        objUser,
      {},
    );
  }

  getAllByParent(id) {
    return this.http.get<any>(
      environment.url +
        environment.usersChild +
        '/getAllByParent?parentUserId=' +
        id,
    );
  }

  maxDataCredito(objUser) {
    return this.http.put<any>(
      environment.url +
        environment.User +
        environment.update +
        '/maxDataCredito',
      objUser,
    );
  }

  updateStoreFounder(payload) {
    return this.http.put<any>(
      environment.url + environment.User + environment.update + '/userByAdmin',
      payload,
    );
  }

  getAllFondeador() {
    return this.http.get<any>(
      environment.url + environment.User + '/getAllFondeador',
    );
  }

  getUserFundeador(id) {
    return this.http.get<any>(environment.url + '/UserFundeador/get?Id=' + id);
  }

  postUserFundeador(storeId: number, payload: any[]) {
    return this.http.post<any>(
      environment.url + '/UserFundeador/post/set?Id=' + storeId,
      payload,
    );
  }

  getRoles() {
    return this.http.get<any>(environment.url + '/RoleAdmin');
  }

  createRole(payload: any) {
    return this.http.post<any>(environment.url + '/RoleAdmin', payload);
  }

  getRoleById(id: number) {
    return this.http.get<any>(environment.url + '/RoleAdmin/' + id);
  }

  assignRole(userId: number, appRoleId: number) {
    return this.http.post<any>(environment.url + '/RoleAdmin/assign-user', {
      userId,
      appRoleId,
    });
  }

  deleteRole(id: number) {
    return this.http.delete<any>(environment.url + '/RoleAdmin/' + id);
  }

  updateRole(payload: any) {
    return this.http.put<any>(environment.url + '/RoleAdmin', payload);
  }

  getAllPermissions() {
    return this.http.get<any>(environment.url + '/PermissionAdmin/catalog');
  }

  getPermissionsByRole(id: number) {
    return this.http.get<any>(environment.url + '/PermissionAdmin/role/' + id);
  }

  assignPermissionsToRole(roleId: number, permissionIds: number[]) {
    return this.http.post<any>(environment.url + '/PermissionAdmin/Role', {
      roleId,
      permissionIds,
    });
  }
}
